<div *ngIf="!isLoading; else loading">
  <div
    class="pt-[16px] gap-[1.6rem] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4 xl:gap-x-7 xl:gap-y-10"
  >
    <div *ngFor="let listing of listings">
      <out-listing-card [listing]="listing"></out-listing-card>
    </div>
  </div>
  <div class="w-full flex justify-center items-center mt-8">
    <out-paginator
      [pageResults]="pageResults"
      [skipResults]="skipResults"
      (pageChange)="onPaginationChange($event)"
    ></out-paginator>
  </div>
</div>

<div class="py-[50px]" *ngIf="!isLoading && noListingsMessage">
  {{ noListingsMessage }}
</div>

<ng-template #loading>
  <div
    class="gap-[1.6rem] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3"
  >
    <div *ngFor="let placeholderSkeleton of placeholderSkeletons">
      <out-listing-skeleton></out-listing-skeleton>
    </div>
  </div>
</ng-template>
